import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-header align-items-center border-0 mt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-boldest text-dark fs-2" }, "Folders"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 mt-2 fw-bold fs-6" }, "32 Active Folders")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-icon-primary btn-active-light-primary me-n3",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body pt-1" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "symbol symbol-40px symbol-circle me-4" }
const _hoisted_9 = { class: "ps-1 mb-1" }
const _hoisted_10 = {
  href: "#",
  class: "fs-5 text-gray-800 text-hover-primary fw-boldest"
}
const _hoisted_11 = { class: "text-gray-400 fw-bold" }
const _hoisted_12 = { class: "badge badge-light rounded-pill fs-7 fw-boldest" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "rounded border border-primary bg-light-primary border-dashed px-6 py-5" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "link-primary fw-bolder fs-6 me-1"
  }, "Intive New .NET Collaborators"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-800 fw-bold fs-6" }, "to creating great outstanding business to business .jsp modular class outstanding scripts")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown3)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass([`mb-${item.space}`, "d-flex flex-stack item-border-hover px-3 py-2 ms-n4"])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                class: _normalizeClass(`symbol-label bg-light-${item.color}`)
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass([`svg-icon-${item.color}`, "svg-icon svg-icon-1"])
                }, [
                  _createVNode(_component_inline_svg, {
                    src: item.icon
                  }, null, 8, ["src"])
                ], 2)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", _hoisted_10, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(item.description), 1)
            ])
          ]),
          _createElementVNode("span", _hoisted_12, _toDisplayString(item.number) + " files", 1)
        ], 2))
      }), 128)),
      _hoisted_13
    ])
  ], 2))
}